import { HttpClient } from '@angular/common/http';
import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { ConfigInitializerService, I18NEXT_INSTANCE, OccEndpointsService } from '@spartacus/core';
import { I18nStateTransferService } from '../services';
import { BaseSiteService, LanguageService } from '../../site-context';
import { i18nextInit, SiteContextI18nextSynchronizer } from './i18next-init';

export const i18nextProviders: EnvironmentProviders = makeEnvironmentProviders([
  provideAppInitializer(() => {
    const initializerFn = i18nextInit(
      inject(I18NEXT_INSTANCE),
      inject(ConfigInitializerService),
      inject(LanguageService),
      inject(BaseSiteService),
      inject(OccEndpointsService),
      inject(HttpClient),
      inject(SiteContextI18nextSynchronizer),
      inject(I18nStateTransferService)
    );
    return initializerFn();
  }),
]);
